import { useMutation } from "@tanstack/react-query";
import { UsuarioService } from "../services/usuario/usuario.service";
import { useAuth } from "../contexts/AuthContext";
import Alert from "../components/shared/alert/Alert";

export const useLogin = () => {
  const { login: authLogin } = useAuth();

  const loginMutation = useMutation({
    mutationFn: async (payload) => {
      const response = await UsuarioService.login(payload);
      return response;
    },
    onSuccess: async (response) => {
      const userData = {
        token: response.docs.token,
        codope: response.docs.codope,
        nomope: response.docs.nomope,
        tipusu: response.docs.tipusu,
        status: response.docs.status
      };

      authLogin(userData);
      return response.docs.status;
    },
    onError: async (error) => {
      const message = error.response?.data?.erro || error.message;
      await Alert({
        title: "Erro",
        message: `Não foi possível realizar o login: ${message}`,
        icon: "error",
        showConfirmButton: true,
        confirmButtonText: "OK",
      });
    },
  });

  return {
    login: loginMutation.mutateAsync, 
    isLoading: loginMutation.isPending,
  };
};